module.exports = __webpack_public_path__ + "static/media/door-is-wrong.c9bf2937.mp3";